exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".carousel-page .content .image[data-v-54f73bfc] {\n  margin-left: 0;\n  margin-right: 0;\n}\n.carousel-page .card-image[data-v-54f73bfc] {\n  max-height: 250px;\n  overflow: hidden;\n}\n.carousel-page .item[data-v-54f73bfc] {\n  display: inline-block;\n  margin: 10px;\n  width: 45%;\n}\n.carousel-page .carousel-image[data-v-54f73bfc] {\n  width: 100%;\n  height: auto;\n}\n.carousel-page .media-content footer[data-v-54f73bfc] {\n  text-align: right;\n}", ""]);

// exports
